// extracted by mini-css-extract-plugin
export default {"list":"list-mL_P1","item":"item-dm9oE","base":"base-MxTOD","left":"left-aiOma","right":"right-LLqCh","title":"title-eYbRs","distance":"distance-zPL6d"};